module.exports = __webpack_public_path__ + "img/timebinder-icon-menu.0a8ff569.svg";